import { Component, Event, EventEmitter, Listen, Prop, State, h } from '@stencil/core';
import { Customer } from '../../../globals/customer';
import { objectHasValues, ErrorHelper } from '../../../helpers';
import { updateLeaseApplication } from '../../../utils';
import { BankInfoTranslation } from '../../../globals/translations';

@Component({
  tag: 'bank-info-state',
  styleUrl: './state-styles/bank-info-state.scss',
  shadow: false,
})
export class BankInfoState {
  @State() isLoading = false;

  @Prop({ mutable: true }) bankInfo: Customer['bankInfo'];
  @Prop({ mutable: true }) errors: ErrorHelper;
  @Prop() translation: Partial<BankInfoTranslation>;

  @Event() updateCustomer: EventEmitter<Partial<Customer>>;
  @Event() continueClick: EventEmitter;

  @Listen('updateBankInfo', { target: 'body' })
  async updateBankInfo(event: CustomEvent) {
    if (event.detail) {
      const { routingNumber, checkingAccountNumber } = event.detail;
      const toUpdate = {
        bankInfo: {
          type: 'checking',
          routing: this.bankInfo.routing,
          account: this.bankInfo.account,
        },
      } as Partial<Customer>;

      if (routingNumber !== this.bankInfo.routing) {
        toUpdate.bankInfo.routing = routingNumber;
        this.bankInfo.routing = routingNumber;
      }

      if (checkingAccountNumber !== this.bankInfo.account) {
        toUpdate.bankInfo.account = checkingAccountNumber;
        this.bankInfo.account = checkingAccountNumber;
      }

      if (objectHasValues(this.bankInfo)) {
        try {
          this.isLoading = true;
          await updateLeaseApplication(toUpdate);
          this.updateCustomer.emit({ bankInfo: this.bankInfo });
          this.continueClick.emit();
        } catch (error) {
          this.errors.hasGenericError = true;
        }
        this.isLoading = false;
      }
    }
  }

  render() {
    return (
      <pc-bank-info {...this.bankInfo} isLoading={this.isLoading} translation={this.translation}>
        {this.errors.hasGenericError && <pc-generic-error slot="error-card" />}
      </pc-bank-info>
    );
  }
}
